import { Heart, Sparkles, HandHeart, Award } from "lucide-react";
import { Link } from "react-router-dom";

export default function About() {
    return (
        <div className="max-w-4xl mx-auto px-4 md:px-8 py-14" data-testid="about-page">
            <div className="text-center">
                <p className="text-xs uppercase tracking-[0.3em] text-[var(--sss-pink)] font-semibold">Our Story</p>
                <h1 className="font-serif-display text-5xl md:text-6xl font-bold mt-3">About Us</h1>
                <Heart size={16} className="inline mt-3 text-[var(--sss-pink)]" fill="#FF2A7A" strokeWidth={0} />
            </div>

            <div className="mt-10 grid md:grid-cols-2 gap-8 items-center">
                <div className="aspect-square rounded-3xl overflow-hidden sss-shadow">
                    <img
                        src="/products/cheesecake-cups.jpg"
                        alt="Sugar Sweet Society treats"
                        className="w-full h-full object-cover"
                    />
                </div>
                <div>
                    <p className="text-[var(--sss-text-muted)] leading-relaxed">
                        Sugar Sweet Society was created with a passion for bringing people together through
                        beautifully crafted, delicious treats. Every box is handmade with love, quality
                        ingredients, and a whole lot of heart.
                    </p>
                    <p className="text-[var(--sss-text-muted)] leading-relaxed mt-4">
                        From chocolate-covered strawberries to candied fruit and signature cheesecake cups,
                        we pour care into each piece — making sure your moments are as sweet as they deserve to be.
                    </p>
                    <Link to="/menu" className="btn-pink mt-6" data-testid="about-shop-button">
                        Shop the Menu <Heart size={14} fill="#fff" strokeWidth={0} />
                    </Link>
                </div>
            </div>

            <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6">
                {[
                    { Icon: HandHeart, t: "Made With Care" },
                    { Icon: Award, t: "Quality Ingredients" },
                    { Icon: Heart, t: "Baked With Love" },
                    { Icon: Sparkles, t: "Made For You" },
                ].map(({ Icon, t }) => (
                    <div key={t} className="text-center bg-white rounded-3xl sss-shadow p-6">
                        <div className="mx-auto w-12 h-12 rounded-full bg-[var(--sss-blush)] flex items-center justify-center">
                            <Icon size={20} className="text-[var(--sss-pink)]" strokeWidth={1.5} />
                        </div>
                        <p className="mt-3 text-sm font-semibold uppercase tracking-wider">{t}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
